<template>
    <div class="btn-properties btn-color-scheme" @click="currentColorScheme = colorScheme" :title="tr(colorScheme.name)"
         :class="{'selected': isSelected, 'transparent': colorScheme.background === `transparent`}" :style="{ background: backgroundStyle }">
        <slot name="prepend"/>
        <slot>
            <template v-if="colorScheme.id">
                <i class="fas fa-text-size preview-title" :style="{ color: colorScheme.title }"/>
                <div class="preview-button" :style="{ background: buttonBackgroundStyle }"/>
            </template>
            <template v-else>
                <i class="fas fa-arrow-turn-down-right preview-title mb-0"/>
                <span class="f-10" v-tr>Inherit|Hériter</span>
            </template>
            <i class="fas fa-check floating-check-mark ml-1" v-if="isSelected"/>
        </slot>
    </div>
</template>

<script>
export default {
    name: `btn-color-scheme`,
    props: {
        value: {type: Object},
        colorScheme: {type: Object}
    },
    computed: {
        currentColorScheme: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit(`input`, value);
            }
        },
        isSelected() {
            if (!this.colorScheme.id)
                return !this.currentColorScheme || Object.keys(this.currentColorScheme).length === 0;

            return this.currentColorScheme && this.currentColorScheme.id === this.colorScheme.id;
        },
        backgroundStyle() {
            return this.cmsWebsite.getColor(this.colorScheme.background);
        },
        buttonBackgroundStyle() {
            return this.cmsWebsite.getColor(this.colorScheme.buttonBG);
        }
    }
}
</script>

<style lang="scss" scoped>
.btn-color-scheme {
    position: relative;
    height: 44px;
    width: 70px;
    margin: 3px;

    .preview-title {
        font-size: 14px;
        font-weight: 700;
        line-height: 1;
        margin-bottom: 6px;
        text-align: center;
    }

    .preview-button {
        border-radius: 8px;
        height: 8px;
        width: 24px;
    }

    &:hover {
        border-color: var(--color-accent);
    }

    &.selected {
        transform: scale(0.95);
        border-color: var(--color-accent);
    }

    &.transparent {
        &::before {
            content: "";
            position: absolute;
            display: block;
            top: 4px;
            left: 4px;
            width: 14px;
            height: 14px;
            border-radius: 4px;
            border: 1px solid #ccc;
            background-color: #fff;
        }
        &::after {
            content: "";
            position: absolute;
            display: block;
            left: 9px;
            top: 1px;
            width: 3px;
            height: 20px;
            transform: rotate(45deg);
            border-radius: 2px;
            background-color: red;
        }
    }
}
</style>
